import { computeHrn, bandFor } from '../constants/riskAssessment';

/**
 * Aggregate residual-HRN stats across a flat list of hazard rows.
 *
 * "max residual" is the operationally meaningful number (the worst remaining
 * risk after controls). Per-band counts add scannable detail for the sticky
 * OverallRiskFooter.
 *
 * Caller is responsible for flattening — e.g.
 *   computeOverallStats((ra.sections || []).flatMap((s) => s.rows || []))
 *   computeOverallStats(blocks.flatMap((b) => b.detail?.rows || []))
 *
 * Returns { count, maxResidual, byBand: {green, yellow, orange, red} }.
 */
export function computeOverallStats(rows) {
  if (!rows || rows.length === 0) {
    return { count: 0, maxResidual: 0, byBand: { green: 0, yellow: 0, orange: 0, red: 0 } };
  }
  let maxResidual = 0;
  const byBand = { green: 0, yellow: 0, orange: 0, red: 0 };
  for (const r of rows) {
    const hrn = computeHrn(r.lo_res, r.fe_res, r.dph_res, r.np_res);
    if (hrn > maxResidual) maxResidual = hrn;
    byBand[bandFor(hrn).tone]++;
  }
  return { count: rows.length, maxResidual, byBand };
}
